import React from 'react';
import Box from '../../../../../common/components/Box/Box';
import { hasPermission } from '../../../../auth/redux/authActions';
import { Link } from 'react-router';
import { get } from 'lodash';

const NotificationsContent = ({ notifications }) => (
  <Box>
    <table className="table not-tab-list" id="not-tab-list--border">
      <thead />
      <tbody>
        <tr>
          <th colSpan="1">Notifications</th>
          <th colSpan="2">Actions</th>
        </tr>
        {/*{get(notifications, 'meta.mtas_requiring_approval', 0) !== 0 && (*/}
        {/*<tr>*/}
        {/*<td colSpan="2">*/}
        {/*You have&nbsp;*/}
        {/*<span className="text-secondary">*/}
        {/*{get(notifications, 'meta.mtas_requiring_approval')}*/}
        {/*</span>*/}
        {/*&nbsp;mid term adjustments requiring approval*/}
        {/*</td>*/}
        {/*<td className="reminder-action">*/}
        {/*<Link to="/policies/mid-term-adjustments?status=quote" onlyActiveOnIndex>View MTAs</Link>*/}
        {/*</td>*/}
        {/*</tr>*/}
        {/*)}*/}

        {get(notifications, 'meta.renewals_awaiting_conversion', 0) !== 0 && (
          <tr>
            <td colSpan="2">
              There are&nbsp;
              <span className="text-secondary">
                {get(notifications, 'meta.renewals_awaiting_conversion')}
              </span>
              &nbsp;renewals awaiting conversion
            </td>
            <td className="reminder-action">
              <Link to="/policies/renewals" onlyActiveOnIndex>
                View Renewals
              </Link>
            </td>
          </tr>
        )}

        {hasPermission('broker.approve') &&
          get(notifications, 'meta.broker_applications_awaiting_approval', 0) !== 0 && (
            <tr>
              <td colSpan="2">
                You have&nbsp;
                <span className="text-secondary">
                  {get(notifications, 'meta.broker_applications_awaiting_approval')}
                </span>
                &nbsp;brokers awaiting approval
              </td>
              <td className="reminder-action">
                <Link to="/broker-applications?status=applied" onlyActiveOnIndex>
                  View Brokers
                </Link>
              </td>
            </tr>
          )}

        {hasPermission('user.edit') &&
          get(notifications, 'meta.users_awaiting_activation', 0) !== 0 && (
            <tr>
              <td colSpan="2">
                You have&nbsp;
                <span className="text-secondary">
                  {get(notifications, 'meta.users_awaiting_activation')}
                </span>
                &nbsp;users yet to log in
              </td>
              <td className="reminder-action">
                <Link to="/admin/users?status=pending" onlyActiveOnIndex>
                  View Users
                </Link>
              </td>
            </tr>
          )}

        {hasPermission('account.view') &&
          get(notifications, 'meta.suspended_accounts', 0) !== 0 && (
            <tr>
              <td colSpan="2">
                There are&nbsp;
                <span className="text-secondary">
                  {get(notifications, 'meta.suspended_accounts')}
                </span>
                &nbsp;suspended accounts
              </td>
              <td className="reminder-action">
                <Link to="/accounts/ledger?suspended=true" onlyActiveOnIndex>
                  View Accounts
                </Link>
              </td>
            </tr>
          )}
      </tbody>
    </table>
  </Box>
);

export default NotificationsContent;
